module.exports = __webpack_public_path__ + "img/pause.ec5a5ade.svg";